// extracted by mini-css-extract-plugin
export default {"updateContactSection":"UpdateContactStatus_updateContactSection__xwrCh","formGroup":"UpdateContactStatus_formGroup__2Pz3x"};